module.exports = __webpack_public_path__ + "static/media/lolly.12892625.png";